import { ProductWithQuantity } from '../model';
import { GTMTrackChangeBasket, GTMCartItem } from '../model/TrackingObject';

export type RemoveFromBasketEvent = {
    event: 'eec_remove';
    ecommerce: {
        basket_id: string;
        currencyCode?: string;
        remove: {
            products: ProductWithQuantity[];
        };
        cartItems?: GTMCartItem[];
    };
};

export const trackRemoveFromBasketEvent = ({
    products,
    currencyCode,
    cartItems,
    basketId
}: GTMTrackChangeBasket): RemoveFromBasketEvent => {
    return {
        event: 'eec_remove',
        ecommerce: {
            basket_id: basketId,
            currencyCode,
            remove: {
                products,
            },
            cartItems
        },
    };
};
